export default {
  title: 'Autentificați-vă la adresa dvs.',
  description:
    'Această adresă aparține unui partener din care contul dvs. nu face parte. Pentru siguranța contului, autentificați-vă unde o faceți de obicei — e-mailul și parola dvs. funcționează acolo.',
  continue: 'Continuați la {{host}}',
  password_changed: 'Parola dvs. a fost schimbată.',
};
